import { Icon } from 'components/icon'
import {
  playerContainerCss,
  playerCss,
  SImage,
  SMemoryItem,
  SPlaceholder,
  SSelectedIcon,
  SThumbnailImage,
  STopInnerShadow,
  SVideoWrapper,
} from './MemoryItem.styled'
import { MemorySelectOption, SelectedMemory } from 'components/memory/MemoryUtils'
import { Spinner } from 'components/spinner/Spinner'
import { AutoPlayer } from 'components/videoPlayer/autoPlayer/AutoPlayer'
import { forwardRef, ReactNode, useState } from 'react'
import { useWindowSize } from 'utils/hooks'
import { StyledLinkProps } from 'utils/styled'

const Placeholder = () => (
  <SPlaceholder>
    <Spinner />
  </SPlaceholder>
)

const VideoPlayOnHover = (props: { src?: string; thumbnail: ReactNode }) => {
  const [hovered, setHovered] = useState(false)

  const { isDesktop } = useWindowSize()

  return (
    <>
      {props.thumbnail}
      {isDesktop && (
        <SVideoWrapper onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
          {hovered && (
            <AutoPlayer
              src={props.src}
              isAuth
              muted
              customPlaceholder={<Placeholder />}
              containerCss={playerContainerCss}
              playerCss={playerCss}
            />
          )}
        </SVideoWrapper>
      )}
    </>
  )
}

export const MemoryItem = forwardRef<
  HTMLDivElement,
  {
    memory: SelectedMemory
    className?: string
    selectionMode?: MemorySelectOption
    selected?: boolean
    onClick: (selectedMemory: SelectedMemory) => void
  } & StyledLinkProps
>(({ memory, selectionMode, selected, onClick, ...props }, ref) => {
  return (
    <SMemoryItem ref={ref} selected={selected} onClick={() => onClick(memory)} {...props}>
      {selected && <SSelectedIcon name="Check" />}
      {memory.selectedAnimation ? (
        <>
          <VideoPlayOnHover
            thumbnail={
              <SThumbnailImage
                src={memory.original_file?.thumbnail_url ?? ''}
                fallbackSrc={memory.original_file?.url ?? ''}
                fill
                alt=""
              />
            }
            src={memory.selectedAnimation.file?.url ?? undefined}
          />

          <STopInnerShadow>
            <Icon name="StarWand" size="1rem" />
          </STopInnerShadow>
        </>
      ) : (
        <SImage
          src={memory.original_file?.url ?? ''}
          layout="fill"
          objectFit="cover"
          selectionMode={selectionMode}
          unoptimized
          alt=""
        />
      )}
    </SMemoryItem>
  )
})
MemoryItem.displayName = 'MemoryItem'
